module.exports = __webpack_public_path__ + "static/CV-short-d8b721ccd879d644f1229e15cab0c533.pdf";